export const withdrawPaymentSwitching = {
  withdrawPaymentSwitching: 'Withdraw Transaction',
  username: 'Username',
  paymentName: 'PaymentName',
  refCode1: 'Ref Code 1',
  status: 'Status',
  transactionId: 'Transaction ID',
  refCode3: 'Ref Code 3',
  createdAt: 'Created At',
  advanceFilter: 'Advance Filter',
  requestedAmount: 'Requested Amount',
  amount: 'Amount',
  message: 'Message',
  feeAmount: 'Fee Amount',
  finalAmount: 'Final Amount',
  reviewReason: 'CM review reason',
  adminDecisionReviewReason: 'Waiting for a CM admin decision',
  financeHoldReviewReason: 'Verify the initial Finance hold result',
  financeDispatchReviewReason: 'Verify the Finance settlement result',
  financeReleaseReviewReason: 'Verify the Finance hold release result',
  providerOutcomeReviewReason: 'The P2Pay request result is unknown',
  providerPendingReviewReason: 'The P2Pay request is pending',
  requestP2PayCancellation: 'Request P2Pay cancellation',
  requestingP2PayCancellation: 'Requesting...',
  p2PayCancellationWaitingCallback: 'Waiting for P2Pay callback',
  p2PayCancellationNeedsReconciliation: 'Result unknown — reconcile',
  confirmP2PayCancellation: 'Request P2Pay to cancel this withdrawal? P2Pay decides whether cancellation is allowed. CM will wait for the P2Pay callback before applying the final state. Do not click again while the request is pending.',
  p2PayCancellationAccepted: 'P2Pay accepted the cancellation request. The final state is pending the P2Pay callback.',
  p2PayCancellationUnknown: 'The cancellation result is unknown. Do not retry. Reconcile the P2Pay state and wait for the callback.',
  p2PayCancellationRejected: 'P2Pay did not allow cancellation in the current state. The row has been refreshed.',
  p2PayCancellationFailed: 'Unable to request P2Pay cancellation. No retry was sent.',
  p2PayCancellationRefreshFailed: 'The action completed, but the list could not be refreshed. Reload the page before taking another action.',
}
